import {determineWindowScrollTopPosition} from "@js/globalFunctions/determineWindowScrollTopPosition";
import {doesUserWantToLeaveFlow} from "@js/parts/bookingflow/doesUserWantToLeaveFlow";

var isSticky = false;
let initialScroll = 0;
$(document).ready(function() {
	$(document).on("click", ".mobileNavBtnEsmark", function(evt){
		if($('body').hasClass('page-template-tmpl-bookingflow'))
		{
			if(!$('body').hasClass('mobile-hovedmenu-active'))
			{
				doesUserWantToLeaveFlow()
				.then(result => {
					toggleHovedMenu(this);
				})
			}
			else
			{
				toggleHovedMenu(this);
			}
		}
		else
		{
			toggleHovedMenu(this);
		}
	});
	
	$(document).on('scroll',function(e){
		if($('body').hasClass('mobile-hovedmenu-active'))
		{
			const currentScroll = determineWindowScrollTopPosition();
			if(Math.abs(currentScroll-initialScroll) > 100)
			{
				$(document).find("#navigation ul:not('.sub-menu')").slideUp();
				$('body').removeClass('mobile-hovedmenu-active');
			}
		}
	});
	
	$(document).on('click touch','.mobile-hovedmenu-active',function(e){
		if($(e.target).closest('.menu-hovedmenu-container').length === 0 && $(e.target).hasClass('swal2-styled') === false)
		{
			$(document).find("#navigation ul:not('.sub-menu')").slideUp();
			$('body').removeClass('mobile-hovedmenu-active');
		}
	});
	
	let lastClickedResponsiveElement = false;
	let showingClickedResponsiveElement = false;
	let lastPreventedEvent = false;
	$(document).on('click', '.menu-item-depth-0', function(e){
		var width = $(window).outerWidth();
		if (width <= 767) {
			if( e.currentTarget !== lastClickedResponsiveElement && $(e.currentTarget).find('.sub-menu').length !== 0 && $(e.target).closest('.sub-menu').length === 0 )
			{
				e.preventDefault();
				if ($(e.currentTarget).hasClass('menu-item-depth-0'))
				{
					lastPreventedEvent = e.timeStamp;
					lastClickedResponsiveElement = e.currentTarget;
					$('.menu-item-depth-0').removeClass('force-show');
					$(e.currentTarget).addClass('force-show');
					$('body').addClass('forcedResponsiveMenuShow');
					showingClickedResponsiveElement = true;
				}
			}
		}
	});
	
	$(document).on('click', '.forcedResponsiveMenuShow', function (e) {
		if ( showingClickedResponsiveElement && !$(e.target).hasClass('force-show') && $(e.target).closest('force-show').length === 0 && e.timeStamp !== lastPreventedEvent ) {
			$('.force-show').removeClass('force-show');
			$('body').removeClass('forcedResponsiveMenuShow');
			showingClickedResponsiveElement = false;
			lastClickedResponsiveElement = false;
		}
	});
	
	$(window).on('scroll',function(){
		updateNavStickyByPosition();
	});
	updateNavStickyByPosition();
});

function updateNavStickyByPosition()
{
	const scrollY = window.scrollY;
	
	const height = $('.page-template-tmpl-bookingflow-php').length === 0 ? 78 : 75 ;
	
	if( isSticky === false && scrollY >= height )
	{
		isSticky = true;
		$('body').addClass('stickyNavBar');
		$('.stickyNavBarSpacer').removeClass('hidden');
	}
	else if( isSticky === true && scrollY <= height )
	{
		isSticky = false;
		$('body').removeClass('stickyNavBar');
		$('.stickyNavBarSpacer').addClass('hidden');
	}
}

function toggleHovedMenu(that){
	$(that).find("i").toggleClass("fa-navicon fa-close");
	$(document).find("#navigation ul:not('.sub-menu')").slideToggle();
	$('body').toggleClass('mobile-hovedmenu-active');
	initialScroll = determineWindowScrollTopPosition();
	
	if( !$('.mobileSearchBtnEsmark').hasClass('isLink') ) {
		$('body').removeClass("searchAreaShown");
		$(document).find("#searcharea").removeClass("showit");
		$(document).find("#search-kat-number").removeClass("showit");
	}
}
